import React, { useState, useEffect } from 'react';
import { Input, Select, Row, Col, Modal, Switch } from 'antd';
import {
  FilterTitleRow,
  PageTitle,
  FilterRow,
  ColStyle,
  FormTitle,
  ModalColumnTitle,
  ModalColumnSwitchItem,
} from './styled';
import DatePickerComp from './DatePicker';
import SummaryColumn from '@src/icons/eco2/summary-column.svg';

const { Search } = Input;

export default function SummaryFilter({ timeInterval, columnList, allMetricList, onFilterChange }) {
  const [showModal, setShowModal] = useState(false);
  const [curColumnList, setCurColumnList] = useState(
    columnList.map((column) => {
      return { ...column };
    }),
  );

  useEffect(() => {
    setCurColumnList(
      columnList.map((column) => {
        return { ...column };
      }),
    );
  }, [columnList]);

  return (
    <>
      <FilterTitleRow>
        <PageTitle>Experience Alerts</PageTitle>
        <DatePickerComp
          value={timeInterval}
          onTimeChange={(value) => {
            onFilterChange('setTimeInterval', value);
          }}
        />
      </FilterTitleRow>
      <FilterRow>
        <Row style={{ width: '100%' }}>
          <Col span={3} style={{ ...ColStyle, paddingLeft: '0' }}>
            <Search
              placeholder="search"
              onSearch={(value) => {
                onFilterChange('setSearchWord', value);
              }}
              style={{ width: '100%' }}
            />
          </Col>
          <Col span={6} style={ColStyle}>
            <FormTitle>Status: </FormTitle>
            <Select
              mode="multiple"
              allowClear
              style={{ width: '100%' }}
              placeholder="Please select"
              defaultValue={[]}
              onChange={(value) => {
                onFilterChange('setStatus', value);
              }}
              options={[
                {
                  value: 'ON-GOING',
                  label: 'ON-GOING',
                },
                {
                  value: 'ENDED',
                  label: 'ENDED',
                },
              ]}
            />
          </Col>
          <Col span={6} style={ColStyle}>
            <FormTitle>Severity: </FormTitle>
            <Select
              mode="multiple"
              allowClear
              style={{ width: '100%' }}
              placeholder="Please select"
              defaultValue={[]}
              onChange={(value) => {
                onFilterChange('setSeverity', value);
              }}
              options={[
                {
                  value: 'INFO',
                  label: 'INFO',
                },
                {
                  value: 'WARNING',
                  label: 'WARNING',
                },
                {
                  value: 'CRITICAL',
                  label: 'CRITICAL',
                },
              ]}
            />
          </Col>
          <Col span={9} style={ColStyle}>
            <FormTitle>Experience Metrics: </FormTitle>
            <Select
              mode="multiple"
              allowClear
              style={{ width: '100%' }}
              placeholder="Please select"
              defaultValue={[]}
              onChange={(value) => {
                onFilterChange('setMetricList', value);
              }}
              options={allMetricList.map((m) => {
                return {
                  value: m,
                  label: m,
                };
              })}
            />
            <SummaryColumn
              style={{ marginLeft: '24px', fontSize: '40px', cursor: 'pointer' }}
              onClick={() => {
                setShowModal(true);
              }}
            />
          </Col>
        </Row>
        <Modal
          title="Experience Alert Fields"
          width={720}
          open={showModal}
          onOk={() => {
            setShowModal(false);
            onFilterChange('setColumnList', curColumnList);
          }}
          onCancel={() => {
            setShowModal(false);
            setCurColumnList(
              columnList.map((column) => {
                return { ...column };
              }),
            );
          }}
        >
          <div>Toggle the viewable fields on the list of Experience Alerts.</div>
          <div>
            {curColumnList.map((column, index) => (
              <ModalColumnSwitchItem key={index}>
                <Switch
                  checked={column.show}
                  onChange={(value) => {
                    const curItem = curColumnList.find((cur) => cur.title === column.title);
                    curItem.show = value;
                    setCurColumnList([...curColumnList]);
                  }}
                ></Switch>
                <ModalColumnTitle>{column.title}</ModalColumnTitle>
              </ModalColumnSwitchItem>
            ))}
          </div>
        </Modal>
      </FilterRow>
    </>
  );
}
